import { Wheel } from "spin-wheel";

export default {
    mounted() {
        console.log("SpinWheel hook mounted!");
        this.initWheel();
    },

    updated() {
        console.log("SpinWheel hook updated!");
        this.initWheel();
    },

    initWheel() {
        const canvas = this.el;

        if (!canvas) return;

        const sectionsData = JSON.parse(canvas.dataset.wheelSections || "[]");

        if (sectionsData.length === 0) return;

        const items = sectionsData.map((section) => ({
            label: `$${this.formatAmount(section.amount / 1000000)}`,
            backgroundColor: section.color,
            labelColor: this.getContrastColor(section.color),
        }));

        const props = {
            items: items,
            rotationResistance: -40,
            itemLabelFontSizeMax: 45,
            itemLabelAlign: "right",
            itemLabelRadius: 0.9,
        };

        console.log("Wheel rendering...");
        this.wheel = new Wheel(canvas, props);

        if (this.preventScroll) {
            canvas.removeEventListener("touchstart", this.preventScroll);
            canvas.removeEventListener("touchmove", this.preventScroll);
        }

        this.preventScroll = (e) => {
            e.preventDefault();
        };

        canvas.addEventListener("touchstart", this.preventScroll, { passive: false });
        canvas.addEventListener("touchmove", this.preventScroll, { passive: false });
    },

    getContrastColor(hexColor) {
        const hex = hexColor.replace("#", "");
        const r = parseInt(hex.substr(0, 2), 16);
        const g = parseInt(hex.substr(2, 2), 16);
        const b = parseInt(hex.substr(4, 2), 16);
        const brightness = (r * 299 + g * 587 + b * 114) / 1000;
        return brightness > 155 ? "#000000" : "#FFFFFF";
    },

    formatAmount(amount) {
        return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    destroyed() {
        if (this.wheel) {
            this.wheel.remove();
        }
        if (this.preventScroll && this.el) {
            this.el.removeEventListener("touchstart", this.preventScroll);
            this.el.removeEventListener("touchmove", this.preventScroll);
        }
    },
};
